module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workspace', [_c('div', {
    attrs: {
      "slot": "form"
    },
    slot: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Board")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.boardFriendly),
      expression: "boardFriendly"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.boardFriendly = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sortedBoards), function(board) {
    return _c('option', [_vm._v(_vm._s(board))])
  }), 0)]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showExamForm) ? _c('div', _vm._l((_vm.exams), function(exam, index) {
    return _c('div', {
      staticClass: "image-group clearfix"
    }, [_c('h3', [_vm._v("Exam")]), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Date")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exam.date),
        expression: "exam.date"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "onFocus": "this.select();"
      },
      domProps: {
        "value": (exam.date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exam, "date", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Location")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exam.location),
        expression: "exam.location"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (exam.location)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exam, "location", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("First Application Deadline")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exam.firstDeadline),
        expression: "exam.firstDeadline"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (exam.firstDeadline)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exam, "firstDeadline", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Final Application Deadline (optional)")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exam.finalDeadline),
        expression: "exam.finalDeadline"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "date"
      },
      domProps: {
        "value": (exam.finalDeadline)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exam, "finalDeadline", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Link to application")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (exam.url),
        expression: "exam.url"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "placeholder": "https://www.example.com"
      },
      domProps: {
        "value": (exam.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(exam, "url", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "form-group"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger pull-right",
      attrs: {
        "id": "removeExam",
        "data-exam": index
      },
      on: {
        "click": _vm.removeExam
      }
    }, [_vm._v("Remove Exam")])])])
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "form-group clearfix"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "id": "showExamForm"
    },
    domProps: {
      "textContent": _vm._s(_vm.exams.length > 0 ? 'Add Another Exam' : 'Add Exam')
    },
    on: {
      "click": _vm.addExam
    }
  })]), _c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Reset")]), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyHtml",
      "aria-label": "Copied HTML!"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy HTML")]), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "id": "copyTextVersion",
      "data-component": _vm.currentTemplate,
      "aria-label": "Copied Text!"
    },
    on: {
      "click": _vm.copyTextVersion
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy text")])])])], 1), _c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "slot": "render",
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    },
    slot: "render"
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center",
      "bgcolor": "#f1f2f2"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "600"
    }
  }, [_c('tr', [_c('td', [_c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "600"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px 10px 10px 10px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "15px 0px 15px 0px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "font-family": "Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "14px",
      "line-height": "26px",
      "color": "#666666",
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.board.boardUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "fluid-image",
    staticStyle: {
      "display": "block",
      "padding": "0",
      "color": "#466687",
      "font-family": "Helvetica, arial, sans-serif",
      "font-size": "16px"
    },
    attrs: {
      "border": "0",
      "src": _vm.board.logoSrc,
      "alt": _vm.board.abbrev,
      "width": _vm.board.logoW,
      "height": _vm.board.logoH
    }
  })])])])])])])])])])])])]), _c('tr', [_c('td', [_c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "600"
    }
  }, [_c('tr', [_c('td', [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('img', {
    staticClass: "fluid-image",
    staticStyle: {
      "display": "block",
      "padding": "0",
      "color": "#466687",
      "font-family": "Helvetica, arial, sans-serif",
      "font-size": "22px",
      "line-height": "28px"
    },
    attrs: {
      "src": "http://aoa-mnews.informz.net/aoa-mnews/data/images/cbs/banner-maintain-your-certification-2.png",
      "width": "600",
      "height": "210",
      "border": "0",
      "alt": "Maintain Your Certification"
    }
  })])])])])])])])])])])]), _c('tr', [_c('td', [_c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "14px 0px 12px 0px"
    },
    attrs: {
      "align": "center",
      "bgcolor": "#ffffff"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "520"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "22px 0px 22px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "bold",
      "font-size": "21px",
      "line-height": "28px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Dear %%name%%,")])]), _c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Thank you for being board certified by the American Osteopathic Association.")])]), _c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Please be advised that your Board Certification in %%specialty%% will expire %%expiration_ap%%.")])]), _c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("You must complete the following requirements to maintain your board certification:")])]), _c('tr', [_c('td', {
    staticClass: "padding"
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top",
      "width": "20"
    }
  }, [_vm._v("1. ")]), _c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "bold",
      "font-size": "16px",
      "line-height": "26px"
    }
  }, [_vm._v("Maintain an active medical license")]), _vm._v(" in any of the US territories and/or Canada (will be verified once other components are complete).")])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top",
      "width": "20"
    }
  }, [_vm._v("2. ")]), _c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "bold",
      "font-size": "16px",
      "line-height": "26px"
    }
  }, [_vm._v("Complete CME Requirements.")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "href": "https://physicianportal.osteopathic.org/TraCMEReport/DownloadTraCMEReport",
      "target": "_blank"
    }
  }, [_vm._v("View your CME report")]), _vm._v(" (log-in required).")])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top",
      "width": "20"
    }
  }, [_vm._v("3. ")]), _c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "bold",
      "font-size": "16px",
      "line-height": "26px"
    }
  }, [_vm._v("Pass the OCC exam.")]), _vm._v(" You are eligible to take the exam in %%years%%.")])])])])]), (_vm.exams.length > 0) ? _c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "10px 0px 20px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "200",
      "font-size": "16px",
      "line-height": "26px",
      "text-transform": "uppercase",
      "letter-spacing": "1px"
    },
    attrs: {
      "align": "center",
      "width": "300"
    },
    domProps: {
      "textContent": _vm._s(_vm.exams.length > 1 ? 'Your OCC exam dates in 2017' : 'Your OCC exam date in 2017')
    }
  })]) : _vm._e(), _vm._l((_vm.exams), function(exam, index) {
    return _c('tr', [_c('td', {
      staticClass: "padding",
      staticStyle: {
        "padding": "0px 0px 40px 0px"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('table', {
      staticClass: "wrapper",
      style: ({
        border: '1px solid #f1f2f2',
        borderRadius: '4px',
        borderCollapse: 'separate !important'
      }),
      attrs: {
        "border": "0",
        "cellpadding": "0",
        "cellspacing": "0",
        "width": "320"
      }
    }, [_c('tr', [_c('td', {
      style: ({
        padding: '6px 10px 6px 10px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#466687',
        fontWeight: 'bold',
        fontSize: '16px',
        lineHeight: '23px'
      }),
      attrs: {
        "align": "center",
        "width": "300",
        "bgcolor": "#f1f2f2"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(exam.date)))])]), _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        padding: '15px 0px 0px 0px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#466687',
        fontWeight: 'normal',
        fontSize: '21px',
        lineHeight: '28px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_vm._v(_vm._s(exam.location))])]), _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        padding: '12px 0px 0px 0px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#a2a2a2',
        fontWeight: 'light',
        fontSize: '13px',
        lineHeight: '18px',
        textTransform: 'uppercase',
        letterSpacing: '1px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_vm._v(_vm._s(exam.finalDeadline ? 'First Application Deadline' : 'Application Deadline'))])]), (exam.finalDeadline) ? _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        padding: '2px 0px 0px 0px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#a2a2a2',
        fontWeight: 'light',
        fontSize: '13px',
        lineHeight: '18px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_vm._v("No late fee")])]) : _vm._e(), _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        padding: (exam.finalDeadline ? '0px 0px 10px 0px' : '0px 0px 0px 0px'),
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#466687',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '26px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(exam.firstDeadline)))])]), (exam.finalDeadline) ? _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        padding: '0px 0px 0px 0px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#a2a2a2',
        fontWeight: 'light',
        fontSize: '13px',
        lineHeight: '18px',
        textTransform: 'uppercase',
        letterSpacing: '1px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_vm._v("Final application deadline")])]) : _vm._e(), (exam.finalDeadline) ? _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        padding: '2px 0px 0px 0px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#a2a2a2',
        fontWeight: 'light',
        fontSize: '13px',
        lineHeight: '18px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_vm._v("With late fee")])]) : _vm._e(), (exam.finalDeadline) ? _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#466687',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '26px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")(exam.finalDeadline)))])]) : _vm._e(), _c('tr', [_c('td', {
      staticClass: "padding-sides-only",
      style: ({
        padding: '0px 0px 20px 0px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        color: '#466687',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '26px'
      }),
      attrs: {
        "align": "center",
        "width": "300"
      }
    }, [_c('table', {
      attrs: {
        "width": "100%",
        "border": "0",
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "padding": "10px 0px 0px 0px"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('table', {
      attrs: {
        "width": "100%",
        "border": "0",
        "cellspacing": "0",
        "cellpadding": "0"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('a', {
      staticClass: "body-text",
      style: ({
        padding: '0px 10px 0px 10px',
        fontSize: '13px',
        lineHeight: '26px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontWeight: 'normal',
        color: '#ffffff',
        textDecoration: 'none',
        textTransform: 'uppercase',
        letterSpacing: '2px',
        backgroundColor: '#466687',
        borderTop: '5px solid #466687',
        borderBottom: '5px solid #466687',
        borderLeft: '20px solid #466687',
        borderRight: '20px solid #466687',
        display: 'inline-block',
        borderRadius: '20px'
      }),
      attrs: {
        "href": exam.url,
        "target": "_blank"
      }
    }, [_vm._v("Apply Now")])])])])])])])])])])])])
  }), _c('tr', [_c('td', {
    staticClass: "padding"
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top",
      "width": "20"
    }
  }, [_vm._v("4. ")]), _c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "bold",
      "font-size": "16px",
      "line-height": "26px"
    }
  }, [_vm._v("Complete Component 4")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "href": "https://physicianportal.osteopathic.org/FiveComponents",
      "target": "_blank"
    }
  }, [_vm._v("Practice Performance Assessment activity")]), _vm._v(".")])])])])]), _c('tr', [_c('td', {
    staticClass: "padding"
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top",
      "width": "20"
    }
  }, [_vm._v("5. ")]), _c('td', {
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "bold",
      "font-size": "16px",
      "line-height": "26px"
    }
  }, [_vm._v("Maintain active AOA membership")]), _vm._v(" (will be verified once other components are complete).")])])])])]), _c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("For more information about the OCC exam or any of the requirements, please visit "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "href": _vm.board.boardUrl,
      "target": "_blank"
    }
  }, [_vm._v("the website of the " + _vm._s(_vm.board.name))]), _vm._v(". ")])]), _c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "0px 0px 15px 0px",
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#717171",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Please contact the " + _vm._s(_vm.board.abbrev) + " at " + _vm._s(_vm.board.phone) + ", or "), _c('a', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "color": "#466687",
      "font-weight": "normal",
      "font-size": "16px",
      "line-height": "26px"
    },
    attrs: {
      "href": 'mailto:' + _vm.board.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.board.email))]), _vm._v(" for specific questions.")])])], 2)])])])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "600"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "20px 10px 20px 10px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "body-text",
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticClass: "appleFooter",
    staticStyle: {
      "font-family": "Helvetica, arial, sans-serif",
      "font-weight": "bold",
      "font-size": "14px",
      "line-height": "21px",
      "color": "#466687",
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.board.boardUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.board.name))])])]), _c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "font-family": "Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "14px",
      "line-height": "21px",
      "color": "#666666"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "appleFooter",
    staticStyle: {
      "color": "#666666",
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.board.address))])])]), _c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "font-family": "Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "14px",
      "line-height": "21px",
      "color": "#666666"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "appleFooter",
    staticStyle: {
      "color": "#666666",
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.board.phone))])])]), _c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "font-family": "Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "14px",
      "line-height": "21px",
      "color": "#666666"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "appleFooter",
    staticStyle: {
      "color": "#666666",
      "font-weight": "normal"
    }
  }, [_vm._v("Questions? Email "), _c('a', {
    staticStyle: {
      "text-decoration": "underline",
      "color": "#666666",
      "font-weight": "normal"
    },
    attrs: {
      "href": 'mailto:' + _vm.board.email,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.board.email))])])])]), _c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "padding-top": "20px",
      "font-family": "Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "13px",
      "line-height": "21px",
      "color": "#666666"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticClass: "appleFooter",
    staticStyle: {
      "font-family": "Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "14px",
      "line-height": "21px",
      "color": "#666666"
    },
    attrs: {
      "href": "http://aoa-mnews.informz.net/aoa-mnews/default.asp?action=u&amp;mi=%%MINSTANCEID%%&amp;email=%%EMAIL%%&amp;fid=2224",
      "target": "_blank",
      "choice": "12"
    }
  }, [_vm._v("Unsubscribe")])])])])])])])])])])])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 0px 36px 0px"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25e76864"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cbs/expiration.vue
// module id = 216
// module chunks = 0